import httpService from '@/modules/common/services/httpService';
import gatewayService from '@/modules/common/services/gatewayService';
import importUtil from '@/modules/import/utils/importUtil';

const downloadTemplateService = httpService.create(
  window.pov_config.VUE_APP_API_URL_GATEWAY,
  false,
  {
    responseType: 'blob',
  },
);

const JOB_TYPES = {
  validate: 'validate',
  execute: 'execute',
};

const PROVIDER_TYPES = {
  excel: 'excel',
  import_job: 'import_job',
};

const basePath = '/business/import';
const uploadBasePath = '/v3/integrations/import_jobs';
const importJobItemsBasePath = '/v3/integrations/import_job_items';

const importService = {
  downloadTemplate(entity, fileName, params = null) {
    return downloadTemplateService.get(`${basePath}/template/download?entity=${entity}`, { ...params })
      .then((response) => {
        importUtil.downloadFile(response.data, fileName);
      })
      .catch((error) => {
        console.error('Error downloading the template file:', error);
        throw error;
      });
  },
  createImportJob(entityType, providerType, providerData, jobType, locale = null, sharedEntityData = null) {
    const formData = new FormData();
    formData.append('entity_type', entityType);
    formData.append('provider_type', providerType);
    if (providerType === PROVIDER_TYPES.import_job) {
      formData.append('provider_data[source_import_job_uid]', providerData);
    } else { // excel
      formData.append('provider_data[file]', providerData);
    }
    formData.append('job_type', jobType);
    if (locale) {
      formData.append('locale', locale);
    }
    if (sharedEntityData) {
      formData.append('shared_entity_data', JSON.stringify(sharedEntityData));
    }
    
    return gatewayService.post(`${uploadBasePath}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }).then((response) => response.data);
  },
  uploadFile(entity, fileData, fileType = PROVIDER_TYPES.excel, locale = 'en') {
    return this.createImportJob(entity, fileType, fileData, JOB_TYPES.validate, locale);
  },
  importJobStatus(jobUid) {
    return gatewayService.get(`${uploadBasePath}/${jobUid}`).then((response) => response.data);
  },
  executeImportJob(entity, jobUid) {
    const formData = new FormData();
    formData.append('entity_type', entity);
    formData.append('provider_type', PROVIDER_TYPES.import_job);
    formData.append('provider_data[source_import_job_uid]', jobUid);
    formData.append('job_type', JOB_TYPES.execute);

    return gatewayService.post(`${uploadBasePath}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }).then((response) => response.data);
  },
  importJobItems(jobUid, page, perPage, filter) {
    const params = {
      import_job_uid: jobUid,
      page,
      per_page: perPage,
      ...filter,
    };
    return gatewayService.get(`${importJobItemsBasePath}`, { ...params })
      .then((response) => response.data);
  },
};

export default importService;
